export default "__VITE_ASSET__1076db43__"